import api from '@shared/services/api';

/**
 * Interface for author statistics
 */
export interface AuthorStats {
  karma: number;
  posts: number;
  comments: number;
}

/**
 * Service to handle author-related operations
 */
export class AuthorService {
  private static BASE_URL = '/spaces';

  /**
   * Get statistics for an author
   * @param authorId The ID of the author
   * @returns Promise with author statistics
   */
  static async getAuthorStats(authorId: string): Promise<AuthorStats> {
    try {
      const { data } = await api.get<AuthorStats>(
        `${this.BASE_URL}/author/${authorId}/stats`
      );
      return data;
    } catch (error) {
      console.error('Error getting author stats:', error);
      // Return default stats in case of error
      return {
        karma: 0,
        posts: 0,
        comments: 0,
      };
    }
  }
}
